var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 3.53678H11.3334V0.870117H2.00008C1.26675 0.870117 0.666748 1.47012 0.666748 2.20345V9.53678H2.00008C2.00008 10.6434 2.89341 11.5368 4.00008 11.5368C5.10675 11.5368 6.00008 10.6434 6.00008 9.53678H10.0001C10.0001 10.6434 10.8934 11.5368 12.0001 11.5368C13.1067 11.5368 14.0001 10.6434 14.0001 9.53678H15.3334V6.20345L13.3334 3.53678ZM4.00008 10.5368C3.44675 10.5368 3.00008 10.0901 3.00008 9.53678C3.00008 8.98345 3.44675 8.53678 4.00008 8.53678C4.55341 8.53678 5.00008 8.98345 5.00008 9.53678C5.00008 10.0901 4.55341 10.5368 4.00008 10.5368ZM13.0001 4.53678L14.3067 6.20345H11.3334V4.53678H13.0001ZM12.0001 10.5368C11.4467 10.5368 11.0001 10.0901 11.0001 9.53678C11.0001 8.98345 11.4467 8.53678 12.0001 8.53678C12.5534 8.53678 13.0001 8.98345 13.0001 9.53678C13.0001 10.0901 12.5534 10.5368 12.0001 10.5368Z",
    fill: "#97A0C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.6c2621f4f76bc1971c614d78331107d0.svg";
export { ForwardRef as ReactComponent };